import { useLocation, useNavigate, useParams } from "react-router-dom";

import { CompanyIconText } from "../components/CompanyIconText/CompanyIconText";
import { CompanyIcon1 } from "../icons/CompanyIcon1";
import { ParticipantIconText } from "../components/ParticipantIconText/ParticipantIconText";
import { ParticipantIcon } from "../icons/ParticipantIcon";
import { ContactIconTextSummary } from "../components/ContactIconText/ContactIconTextSummary";

import studyProgrammes from "../data/studyProgrammes.json";
import workshops from "../data/workshops.json";
import events from "../data/events.json";
import terms from "../data/terms.json";
import Header from "../components/Header";
import { Col, Container, Row } from "react-bootstrap";
import SocialIcons from "../components/SocialIcons/SocialIcons";

function getStudyProgramme(studyLevel, studyProgramme) {
  const foundProgrammes = studyProgrammes[studyLevel];

  const foundProgramme = foundProgrammes.find((p) => {
    return p.value === studyProgramme;
  });

  return foundProgramme.title;
}

function getItem(itemValue, items) {
  const foundItem = items.find((i) => {
    return i.value === itemValue;
  });

  return foundItem.title;
}

function DisplayRegistrationStudent({ data }) {
  return (
    <>
      <Row>
        <Col md={{ offset: 3, span: 6 }}>
          <div className="title-box">
            <p>Uspešna prijava na konferenco OTS</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <div className="heading">
            <p>
              Zahvaljujemo se vam za prijavo na{" "}
              <span>
                <a href="https://www.ots.si/">konferenco OTS.</a>
              </span>
            </p>
            <p>
              Veselimo se srečanja z vami. Vidimo se{" "}
              <span>2. in 3. septembra v Mariboru.</span>
            </p>
            <p>
              Po prijavi boste na elektronski naslov prejeli sporočilo s
              potrdilom o prijavi.
            </p>
            <p>
              V nadaljevanju so navedeni prijavni podatki, ki jih lahko izvozite
              in <span>natisnete.</span>
            </p>
            <p>
              Hvala in lep pozdrav, <br /> Organizatorji konference OTS
            </p>
            <div className="print">
              <input
                type="button"
                className="primary-button"
                value="Natisni"
                onClick={(e) => window.print()}
              />
            </div>
          </div>
        </Col>
        <Col>
          <SocialIcons />
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <div className="obrazec">
            <div className="div-round">
              <div className="frame">
                <div className="frame-2">
                  <div className="icon-text-wrapper">
                    <ParticipantIconText
                      text={`UDELEŽENEC / UDELEŽENKA`}
                      className="design-component-instance-node"
                      icon={
                        <ParticipantIcon className="uporabnik-icon-instance" />
                      }
                    />
                  </div>
                </div>
              </div>
              <Row>
                <Row>
                  <Col md={{ offset: 1, span: 4 }}>
                    <p className="title">Ime in priimek:</p>
                  </Col>
                  <Col md={7}>
                    <p className="value">
                      {data.firstName} {data.lastName}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col md={{ offset: 1, span: 4 }}>
                    <p className="title">Elektronski naslov:</p>
                  </Col>
                  <Col md={7}>
                    <p className="value">{data.email}</p>
                  </Col>
                </Row>
                <Row>
                  <Col md={{ offset: 1, span: 4 }}>
                    <p className="title">Vpisna številka:</p>
                  </Col>
                  <Col md={6n}>
                    <p className="value">{data.studentId}</p>
                  </Col>
                </Row>
                <Row>
                  <Col md={{ offset: 1, span: 4 }}>
                    <p className="title">Stopnja študija:</p>
                  </Col>
                  <Col md={6n}>
                    <p className="value">{data.studyLevel}</p>
                  </Col>
                </Row>
                <Row>
                  <Col md={{ offset: 1, span: 4 }}>
                    <p className="title">Studijski program:</p>
                  </Col>
                  <Col md={7}>
                    <p className="value">
                      {getStudyProgramme(
                        data.studyLevel.toLowerCase(),
                        data.studyProgramme
                      )}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col
                    md={{ offset: 1, span: 4 }}
                    className="pt-3 pt-md-0 pt-lg-0"
                  >
                    <p className="title">Letnik študija:</p>
                  </Col>
                  <Col md={7}>
                    <p className="value">{data.studyYear}</p>
                  </Col>
                </Row>
                <Row>
                  <Col
                    md={{ offset: 1, span: 4 }}
                    className="d-flex align-items-top"
                  >
                    <p className="title">Prijava na delavnico:</p>
                  </Col>
                  <Col md={7}>
                    <div className="value">
                      <ul className="ps-3">
                        {data.workshops.map((w, index) => {
                          return <li key={index}>{getItem(w, workshops)}</li>;
                        })}
                      </ul>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={{ offset: 1, span: 4 }}>
                    <p className="title">Obvestila o prihajajočih dogodkih:</p>
                  </Col>
                  <Col md={7}>
                    <div className="value">
                      <ul className="ps-3">
                        {data.terms.length === 0 && (
                          <li>
                            Želim, da me obveščate o prihajajočih dogodkih
                          </li>
                        )}
                        {data.terms.length !== 0 &&
                          data.terms.map((t, index) => {
                            return <li key={index}>{getItem(t, terms)}</li>;
                          })}
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
}

function DisplayRegistration({ data }) {
  return (
    <>
      <Row>
        <Col md={{ offset: 3, span: 6 }}>
          <div className="title-box">
            <p>Uspešna prijava na konferenco OTS</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <div className="heading">
            <p>
              Zahvaljujemo se vam za prijavo na{" "}
              <span>
                <a href="https://www.ots.si/" target="blank">
                  konferenco OTS.
                </a>
              </span>{" "}
            </p>
            <p>
              Veselimo se srečanja z vami. Vidimo se{" "}
              <span>2. in 3. septembra v Mariboru.</span>
            </p>
            <p>
              Prijava velja kot naročilnica. Račun za plačilo kotizacije bo
              izstavljen po izvedbi konference.
            </p>{" "}
            <br />
            <p>
              V nadaljevanju so navedeni prijavni podatki, ki jih lahko izvozite
              in <span>natisnete.</span>
            </p>
            <p className="pt-5">
              Hvala in lep pozdrav, <br /> Organizatorji konference OTS
            </p>
            <div className="print">
              <input
                type="button"
                className="primary-button"
                value="Natisni"
                onClick={(e) => window.print()}
              />
            </div>
          </div>
        </Col>
        <Col>
          <SocialIcons />
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          <div className="obrazec">
            <div className="div">
              <div className="icon-text-wrapper">
                <CompanyIconText
                  className="design-component-instance-node"
                  icon={<CompanyIcon1 className="podjetje-icon" />}
                />
              </div>

              <Row>
                <Col>
                  <Row>
                    <Col md={{ offset: 1, span: 4 }}>
                      <p className="title">Naziv:</p>
                    </Col>
                    <Col md={7}>
                      <p className="value">{data.companyName}</p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ offset: 1, span: 4 }}>
                      <p className="title">Naslov:</p>
                    </Col>
                    <Col md={7}>
                      <p className="value">
                        {data.companyAddress}, {data.companyZip}{" "}
                        {data.companyCity}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ offset: 1, span: 4 }}>
                      <p className="title">Davčna:</p>
                    </Col>
                    <Col md={7}>
                      <p className="value">{data.vatId}</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <div
              className={data.participants.length === 1 ? "div-round" : "div"}
            >
              <div className="frame">
                <div className="frame-2">
                  <div className="icon-text-wrapper">
                    <ParticipantIconText
                      text={`UDELEŽENCI`}
                      className="design-component-instance-node"
                      icon={
                        <ParticipantIcon className="uporabnik-icon-instance" />
                      }
                    />
                  </div>
                </div>
              </div>

              {data.participants.map((p, index) => {
                return (
                  <Row key={index}>
                    <Col md={{ offset: 1, span: 11 }}>
                      <p className="participant-title">
                        UDELEŽENEC / UDELEŽENKA
                      </p>
                    </Col>
                    <Col className="pt-3 pt-md-0">
                      <Row>
                        <Col md={{ offset: 1, span: 4 }}>
                          <p className="title">Ime in priimek:</p>
                        </Col>
                        <Col md={7}>
                          <p className="value">
                            {p.firstName} {p.lastName}
                          </p>
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          md={{ offset: 1, span: 4 }}
                          className="d-flex align-items-center"
                        >
                          <p className="title">Elektronski naslov:</p>
                        </Col>
                        <Col md={7}>
                          <p className="value">{p.email}</p>
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          md={{ offset: 1, span: 4 }}
                          className="d-flex align-items-center"
                        >
                          <p className="title">Tip kotizacije:</p>
                        </Col>
                        <Col md={7}>
                          <p className="value">{p.registrationType}</p>
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          md={{ offset: 1, span: 4 }}
                          className="d-flex align-items-center"
                        >
                          <p className="title">Oblika zbornika:</p>
                        </Col>
                        <Col md={7}>
                          <p className="value">{p.proceedingsFormat}</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          md={{ offset: 1, span: 4 }}
                          className="d-flex align-items-center"
                        >
                          <p className="title">Majica:</p>
                        </Col>
                        <Col md={7}>
                          {p.tshirt !== "NONE" && (
                            <p className="value">
                              {p.tshirt === "MALE" ? "Moška" : "Ženska"} (
                              {p.tshirtSize})
                            </p>
                          )}
                          {p.tshirt === "NONE" && <p className="value">Ne</p>}
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          md={{ offset: 1, span: 4 }}
                          className="d-flex align-items-top"
                        >
                          <p className="title">Prijava na delavnico:</p>
                        </Col>
                        <Col md={7}>
                          <div className="value">
                            <ul className="ps-3">
                              {p.workshops.map((w, index) => {
                                return (
                                  <li key={index}>{getItem(w, workshops)}</li>
                                );
                              })}
                            </ul>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          md={{ offset: 1, span: 4 }}
                          className="d-flex align-items-top"
                        >
                          <p className="title">Udeležil(a) se bom:</p>
                        </Col>
                        <Col md={7}>
                          <div className="value">
                            <ul className="ps-3">
                              {p.events.map((e, index) => {
                                return (
                                  <li key={index}>{getItem(e, events)}</li>
                                );
                              })}
                            </ul>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={{ offset: 1, span: 4 }}>
                          <p className="title">Posebne prehranske zahteve:</p>
                        </Col>
                        <Col md={7}>
                          <p className="value">
                            {p.specialDietary === "" ? "/" : p.specialDietary}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={{ offset: 1, span: 4 }}>
                          <p className="title">
                            Obvestila o prihajajočih dogodkih:
                          </p>
                        </Col>
                        <Col md={7}>
                          <div className="value">
                            <ul className="ps-3">
                              {p.terms.length === 0 && (
                                <li>
                                  Želim, da me obveščate o prihajajočih dogodkih
                                </li>
                              )}
                              {p.terms.length !== 0 &&
                                p.terms.map((t, index) => {
                                  return (
                                    <li key={index}>{getItem(t, terms)}</li>
                                  );
                                })}
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                );
              })}
            </div>
            {data.participants.length > 1 && (
              <div className="div-contact">
                <div className="icon-text-wrapper">
                  <ContactIconTextSummary />
                </div>
                <Row>
                  <Col>
                    <Row>
                      <Col md={{ offset: 1, span: 4 }}>
                        <p className="title">Ime in priimek:</p>
                      </Col>
                      <Col md={7}>
                        <p className="value">
                          {data.contact.firstName} {data.contact.lastName}
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={{ offset: 1, span: 4 }}>
                        <p className="title">Elektronski naslov:</p>
                      </Col>
                      <Col md={7}>
                        <p className="value">{data.contact.email}</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={{ offset: 1, span: 4 }}>
                        <p className="title">Telefonska številka:</p>
                      </Col>
                      <Col md={7}>
                        <p className="value">{data.contact.phone}</p>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
}

export default function Summary({ props }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { type } = useParams();

  console.log(location);
  console.log(navigate);

  const data = { ...location.state };
  let summary = null;

  switch (type) {
    case "podjetje":
      summary = <DisplayRegistration data={data} />;
      break;
    case "student":
      summary = <DisplayRegistrationStudent data={data} />;
      break;
    default:
      summary = null;
      break;
  }

  // if manualy entered URL

  if (
    location.state === undefined ||
    location.state === null ||
    location.state === ""
  ) {
    // window.location = "https://www.ots.si/";
  }
  return (
    <>
      <Container fluid>
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <Header url="/" />
          </Col>
        </Row>
        <Row>
          {location.state === null && (
            <div className="content">
              <div className="obrazec">
                <div className="div">Not Allowed...</div>
              </div>
            </div>
          )}
        </Row>
        {location.state !== null && summary}
      </Container>
      <img
        className="bottomImg"
        src="../images/bottom-bg.png"
        alt=""
      />      
      {/* <!-- img
        className="bottomImg"
        src="https://ots.si/prijava/images/bottom-bg.png"
      / --> */}
    </>
  );
}
